import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { AcademyAssistantIcon } from '../AcademyAssistantIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DrawerEmptyState = () => {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "200",
    padding: "300",
    flex: 1,
    children: [/*#__PURE__*/_jsx(AcademyAssistantIcon, {
      size: 48
    }), /*#__PURE__*/_jsx(Text, {
      typography: "heading-100",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academy-ai-assistant.drawer.emptyState.heading"
      })
    }), /*#__PURE__*/_jsx(Text, {
      typography: "body-100",
      color: "text-core-disabled",
      textAlign: "center",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academy-ai-assistant.drawer.emptyState.body"
      })
    })]
  });
};